import { create } from "zustand";

import { ACCOUNT_STATUS, Customer } from "../models/Customer";

type State = Customer;

type Actions = {
  setCustomer: (state: Customer) => void;
  setUnlinkCustomer: (id: string) => void;
  setDeleteCustomer: (id: string) => void;
};

const customerStore = create<State & Actions>(set => ({
  // State
  users: [],
  pagination: {
    currentPage: 1,
    pageSize: 12,
    totalPages: 0,
  },

  setCustomer: newState =>
    set(() => ({
      ...newState,
    })),

  setUnlinkCustomer: id =>
    set(state => ({
      ...state,
      users: state.users.map(item =>
        item.omneId === id ? { ...item, insuranceLinkedDate: "" } : item,
      ),
    })),

  setDeleteCustomer: id =>
    set(state => ({
      ...state,
      users: state.users.map(item =>
        item.omneId === id
          ? { ...item, accountStatus: ACCOUNT_STATUS.TOBEDELETED }
          : item,
      ),
    })),
}));

export const useCustomerStore = () => {
  return customerStore(store => ({
    users: store.users,
    pagination: store.pagination,
  }));
};

export const useSetCustomerStore = () => {
  return customerStore(store => store.setCustomer);
};

export const useSetUnlinkCustomerStore = () => {
  return customerStore(store => store.setUnlinkCustomer);
};

export const useSetDeleteCustomerStore = () => {
  return customerStore(store => store.setDeleteCustomer);
};
